import React from "react";
import {classNames} from "@utils/class-names";

interface RedoButtonProps {
    onRedo: () => void;
}

const RedoButton = ({onRedo}: RedoButtonProps) => {
    return (
        <button
            type="button"
            onClick={onRedo}
            className={classNames(
                "px-2 w-10 h-10 hover:bg-on-surface/5 rounded-full flex items-center justify-center"
            )}
            title="Powtórz (Ctrl+Y)"
        >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
                 strokeLinecap="round" strokeLinejoin="round">
                <polyline points="23 4 23 10 17 10"/>
                <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
            </svg>
        </button>
    );
};

export default RedoButton;